import { RootState } from "../RootReducer";
import { IEventFilters } from "./ActionTypes";
import { ICategory, IEvent } from "./Event";

export const Events = (state: RootState): IEvent[] => state.events.eventList;
export const FilteredEvents = (state: RootState): IEvent[] => state.events.filteredEventList;
export const Categories = (state: RootState): ICategory[] => state.events.categoryList;
export const EventsLoading = (state: RootState): boolean => state.events.loading;
export const EventsPageScrollPosition = (state: RootState): number => state.events.eventsPageState.scrollPosition;
export const EventsPageFilters = (state: RootState): IEventFilters | undefined => state.events.eventsPageState.filters;